import ContratExoEtranger from '@/generated/controls/contrat/ContratExoEtranger.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ContratExoEtranger
})
